( function( $ ) {

    /**
     * AVATARS FUNCTIONALITY
     */
    let gallery = $( '#zipline_smart_avatars-create-gallery' );

    // Confirm modal HTML
    const message = '<h2>Are you sure you want to clear your gallery?</h2>';
    const ok = '<button id="clear-gallery-ok" class="button-primary">Clear Gallery</button>';
    const cancel = '<button id="clear-gallery-cancel" class="button">Cancel</button>';
    const confirmModal = $( `<div> <div id="confirm-modal-inner"> ${message} <div class="button-wrap"> ${ok} ${cancel} </div> </div> </div>` ).attr( 'id', 'confirm-modal' );

    // Disable the (redux) clear gallery button when clicked
    $( '#clear-gallery' ).prop( 'disabled', true ).on( 'click', function() {

        // If the button is disabled, modal is not showing and no avatars have been added then output modal
        if ( $( '#clear-gallery' ).prop( 'disabled', true ) && 0 === $( '#confirm-modal' ).length && 0 !== $( '.screenshot' ).contents().length ) {
            confirmModal.appendTo( 'body' );

            if ( 0 !== $( '#confirm-modal' ).length ) {
                $( 'html, body' ).css({
                    overflow: 'hidden',
                    height: '100%'
                });
            }

            $( '#clear-gallery-ok' ).on( 'click', function() {
                closeConfirmModalAndClearAvatars();
            });

            $( '#clear-gallery-cancel' ).on( 'click', function() {
                closeConfirmModal();
            });
        }
    });

    function closeConfirmModalAndClearAvatars() {

        // Remove value from input.
        gallery.find( '.gallery_values' ).val( '' );

        // Remove preview images.
        gallery.find( '.screenshot' ).html( '' );

        // Display save notice
        $( '.redux_notification_bar' ).css( 'display', 'block' );
        $( '.redux-save-warn' ).css( 'display', 'block' );

        closeConfirmModal();
    }

    function closeConfirmModal() {
        $( '#confirm-modal' ).remove();
        $( 'html, body' ).css({
            overflow: 'scroll',
            height: 'auto'
        });
    }

    /**
     * OVERLAYS ON SETTINGS PAGES WHEN PRO VERSION NOT ACTIVE
     */
    // Check if the pro version is active
    const proEnabled = zl_smart_avatars.pro_enabled;

    $( '.redux-group-menu li:gt(0)' ).on( 'click', function() {

        if ( ! proEnabled ) {

            // Check if the overlay exists
            let overlayExists = $( '.overlay' ).length > 0;

            if ( ! overlayExists && $( this ).index() >= 1 && $( this ).index() < 5 ) {
                const overlay = $( '<div class="overlay"></div>' );
                const notice = $(
                    '<div class="notice">' +
                    '<h3>These options are only available with Smart Avatars Pro add on. To download please visit ' +
                    '<a href="https://my.ziplinecommunities.com/product/smart-avatars-pro/" target="_blank">Zipline Communities</a>' +
                    '</h3>' +
                    '</div>'
                );

                // Wrap the overlay around the settings page
                $( '.redux-main' ).contents().wrapAll( overlay );
                $( '.overlay' ).before( notice );
            }
            $( '.overlay' ).removeClass( 'allow-interaction' );
        }

    });

    $( '.redux-group-menu li:first-child' ).on( 'click', function() {

        // Check if the overlay exists
        let overlayExists = $( '.overlay' ).length > 0;
        if ( overlayExists ) {
            const overlayDiv = $( '<div class="overlay"></div>' );

            // Wrap the overlay around the settings page
            $( '.overlay' ).addClass( 'allow-interaction' );
            $( '.notice' ).remove();
            const contents = $( '.overlay' ).contents();
            $( '.overlay' ).replaceWith( contents );
        }
    });
}( jQuery ) );
